/**
 * Scene.ts — base class for all scenes. A scene is a Pixi Container with a
 * lifecycle: enter (mounted), update (per-frame), resize, and exit (teardown).
 */
import { Container } from 'pixi.js';
import type { AppContext } from './AppContext';
import type { Viewport } from './AppContext';

export abstract class Scene extends Container {
  protected ctx!: AppContext;

  /** Called once when the scene is created, before enter(). */
  init(ctx: AppContext): void {
    this.ctx = ctx;
  }

  /** Called when the scene becomes active (after fade-in starts). */
  abstract enter(): void;

  /** Per-frame; dtMs is elapsed milliseconds. */
  update(_dtMs: number): void {}

  /** Layout to the given viewport. */
  abstract layout(v: Viewport): void;

  /** Called when the scene is removed; free resources. */
  exit(): void {}
}
